.header {
  grid-area: header;
  display: flex;
  align-items: center;
  gap: var(--space-s);
  justify-content: flex-end;

  & > * {
    margin: unset !important;
  }
}
